import * as React from 'react'
import type { SVGProps } from 'react'
function SvgMsKlimadashboardIconsKlimakenntageTropennacht(
  props: SVGProps<SVGSVGElement>,
) {
  return (
    <svg
      data-name="Ebene 1"
      viewBox="0 0 211.07 227"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <defs>
        <style>{'.kkt-icon-tn{fill:#6060d6}'}</style>
      </defs>
      <g className="kkt-icon-tn" id="c">
        <path d="M113.52,227C50.92,227,0,176.07,0,113.47c0-29.71,11.4-57.81,32.1-79.11C52.76,13.1,80.42.9,110,0c1.48-.05,2.84.86,3.38,2.25.53,1.39.12,2.97-1.02,3.93-21.48,18.03-33.8,44.45-33.8,72.48,0,52.18,42.45,94.64,94.63,94.64,11.42,0,22.58-2.01,33.16-5.97,1.4-.52,2.97-.1,3.92,1.05.95,1.15,1.07,2.78.29,4.05-20.8,34.17-57.08,54.57-97.04,54.57ZM100.39,7.74c-24.01,2.94-46.2,13.91-63.27,31.49C17.7,59.23,7,85.59,7,113.47c0,58.74,47.78,106.53,106.52,106.53,34.19,0,65.5-15.91,85.56-43.02-8.4,2.21-17.08,3.33-25.89,3.33-56.04,0-101.63-45.59-101.63-101.64,0-26.69,10.4-52.02,28.84-70.92Z" />
      </g>
    </svg>
  )
}
export default SvgMsKlimadashboardIconsKlimakenntageTropennacht
